import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { aboutContent } from '../../data/mock';

const AboutPreview = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24 lg:py-32 bg-white relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-[#E8A5C4]/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-[#C45B9F]/10 rounded-full blur-3xl translate-x-1/2 translate-y-1/2" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div
            className={`relative transition-all duration-1000 ${
              isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'
            }`}
          >
            <div className="relative">
              <div className="relative overflow-hidden rounded-[2rem]">
                <img
                  src={aboutContent.image}
                  alt="À propos de Tevaite"
                  className="w-full h-[500px] object-cover"
                />
              </div>
              {/* Decorative frame */}
              <div className="absolute -bottom-4 -right-4 w-full h-full border-2 border-[#C45B9F] rounded-[2rem] -z-10" />
            </div>
          </div>

          {/* Content */}
          <div
            className={`space-y-8 transition-all duration-1000 delay-200 ${
              isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'
            }`}
          >
            <div>
              <span className="text-[#C45B9F] font-medium uppercase tracking-wider text-sm">
                Notre histoire
              </span>
              <h2 className="font-heading text-4xl lg:text-5xl text-[#3D2E35] mt-4 leading-tight">
                {aboutContent.subtitle}
              </h2>
            </div>

            <div className="space-y-6">
              {aboutContent.paragraphs.slice(0, 2).map((paragraph, index) => (
                <p key={index} className="text-[#6B5A62] leading-relaxed">
                  {paragraph}
                </p>
              ))}
            </div>

            <Link
              to="/about"
              className="inline-flex items-center text-[#8B4B7C] hover:text-[#C45B9F] font-medium transition-colors duration-300 group"
            >
              En savoir plus
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform duration-300" size={20} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPreview;
